import type { Directive } from 'vue'
import type { Environnements } from '@/features/application/shared/Environnements.types'

export type EnvDirectiveValue =
  | { autorise: Environnements[]; refuse?: undefined }
  | { autorise?: undefined; refuse: Environnements[] }

export const vEnvironnement: Directive<HTMLElement, EnvDirectiveValue> = {
  mounted(el, binding) {
    const { autorise = [], refuse = [] } = binding.value ?? {}
    const currentEnv = import.meta.env.VITE_ENV as Environnements

    if (autorise.length > 0 && !autorise.includes(currentEnv)) {
      el.style.display = 'none'
      return
    }
    if (refuse.length > 0 && refuse.includes(currentEnv)) {
      el.style.display = 'none'
    }
  },
}
declare module 'vue' {
  interface GlobalDirectives {
    vEnvironnement: typeof vEnvironnement
  }
}
